import apiKeyHttpClient from './apiKeyHttpClient';

// Public booking API using API key authentication
export const publicBookingApi = {
  // Get doctors for public booking
  getDoctors: async () => {
    const response = await apiKeyHttpClient.get('/public-booking/doctors');
    return response.data;
  },

  // Get locations for public booking
  getLocations: async () => {
    const response = await apiKeyHttpClient.get('/public-booking/locations');
    return response.data;
  },

  // Get available slots for a doctor on a specific date
  getAvailableSlots: async (doctorId: string, date: string) => {
    const response = await apiKeyHttpClient.get(`/public-booking/available-slots?doctorId=${doctorId}&date=${date}`);
    return response.data;
  },

  // Create patient for public booking
  createPatient: async (patientData: any) => {
    const response = await apiKeyHttpClient.post('/public-booking/patients', patientData);
    return response.data;
  },

  // Create appointment for public booking
  createAppointment: async (appointmentData: any) => {
    const response = await apiKeyHttpClient.post('/public-booking/appointments', appointmentData);
    return response.data;
  },

  // Combined patient + appointment creation (using the backend's combined endpoint)
  bookAppointment: async (data: { patientData: any; appointmentData: any }) => {
    const response = await apiKeyHttpClient.post('/public-booking/book-appointment', data);
    return response.data;
  },

  // Legacy method for backward compatibility
  registerPatientAndBookAppointment: async (data: { patientData: any; appointmentData: any }) => {
    return publicBookingApi.bookAppointment(data);
  }
};

export default publicBookingApi;
